import React, { useEffect, useState } from "react";
import Select from "react-select";
import { BASE_URL } from "../env.js";
import axios from "axios";
import { developAxios } from "../axios.config.js";
type Props = {};

function StudentCourseResults({}: Props) {
	const [course, setCourse] = useState({ courseName: "", courseValue: "" });
	const [courses, setCourses] = useState([]);
	const [name, setName] = useState("");
	const [result, setResult]: any = useState(null);
	const [page, setPage] = useState<number>(0);
	const handleSelect = (course: any) => {
		setPage(0);
		setCourse({ courseName: course.label, courseValue: course.value });
	};

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				const allcourses = data?.courses.map((each: any) => {
					return {
						label: each.name,
						value: each._id,
					};
				});
				setCourses(allcourses);
			});
	}, []);
	const fetchStudents = async () => {
		let param: any = {
			courseId: course.courseValue,
			page: `${page}`,
			limit: "10",
		};
		if (name) {
			param = {
				...param, // Use spread operator to retain original properties
				query: name,
			};
		}
		console.log(param);
		const token: any = localStorage.getItem("token");
		developAxios(token)
			.get("/admin/user/search-user", {
				params: param,
			})
			.then((response) => {
				const data = response.data;
				if (data.users.length > 0) {
					setResult(data.users);
				} else {
					setResult("empty");
				}
			})
			.catch((error) => {
				console.error(
					"An error occurred during the API request:",
					error.response
				);
			});
	};

	const changePage = async (pageNo: number) => {
		console.log(pageNo);
		setPage((odpage) => pageNo);
	};
	useEffect(() => {
		if (course.courseName) {
			console.log(page);
			fetchStudents();
		}
	}, [page]);

	return (
		<>
			<div className="flex flex-col items-center justify-center">
				<Select
					onChange={handleSelect}
					options={courses}
					className="md:w-[70vw] w-[90vw] max-w-md border border-black rounded-md  my-4"
				/>
				<input
					onChange={(e) => {
						setResult(null);
						setPage(0);
						setName(e.target.value);
					}}
					value={name}
					className="md:w-[70vw] w-[90vw] max-w-md border border-black rounded-md px-4 py-2 mb-4"
					type="search"
					placeholder="Enter Name of Student"
				/>
				<button
					className="p-2 border-[2px] border-green-800"
					onClick={fetchStudents}
				>
					Search
				</button>
			</div>
			{result ? (
				result != "empty" ? (
					<>
						<UserTable data={result} />

						<div className="w-full my-4 flex flex-row gap-3 items-center justify-center">
							<button
								className={
									page === 0
										? "bg-blue-200 p-2"
										: "bg-blue-500 p-2"
								}
								onClick={() => {
									if (page === 0) {
										alert("you are at first page");
									} else {
										changePage(page - 1);
									}
								}}
							>
								prev
							</button>
							<div className="p-2 border-[2px] px-3 border-black">
								{page + 1}
							</div>
							<button
								className="bg-blue-500 p-2"
								onClick={() => changePage(page + 1)}
							>
								next
							</button>
						</div>
					</>
				) : (
					<>
						<h1>No Student Found</h1>
						<div className="w-full my-4 flex flex-row gap-3 items-center justify-center">
							<button
								className={
									page === 0
										? "bg-blue-200 p-2"
										: "bg-blue-500 p-2"
								}
								onClick={() => {
									if (page === 0) {
										alert("you are at first page");
									} else {
										changePage(page - 1);
									}
								}}
							>
								prev
							</button>
							<div className="p-2 border-[2px] px-3 border-black">
								{page + 1}
							</div>
							<button
								onClick={() => alert("no more results")}
								className="bg-blue-200 p-2"
							>
								next
							</button>
						</div>
					</>
				)
			) : null}
		</>
	);
}

const UserTable = ({ data, pageNo, changePage }: any) => {
	return (
		<>
			<div className="w-full mx-auto p-4 bg-white shadow rounded-lg">
				<h1 className="text-xl font-semibold mb-4">User Table</h1>
				<table className="min-w-full border bg-white">
					<thead>
						<tr className="bg-gray-50">
							<th className="border px-4 py-2">ID</th>
							<th className="border px-4 py-2">First Name</th>
							<th className="border px-4 py-2">Last Name</th>
							<th className="border px-4 py-2">Email</th>
						</tr>
					</thead>
					<tbody>
						{data.map((student: any) => (
							<tr key={student._id} className="odd:bg-gray-100">
								<td className="border px-4 py-2">
									{student.firstName}
								</td>
								<td className="border px-4 py-2">
									{student.lastName}
								</td>
								<td className="border px-4 py-2">
									{student.email}
								</td>
								<td className="border px-4 py-2">
									{student._id}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</>
	);
};

export default StudentCourseResults;
